var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.ready)?_c('business-profile-cdc-module',{attrs:{"person":_vm.person}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }